
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { BasicInfoComponent } from '../../management/create-account/steps/basic-info/basic-info.component';
import { Observable, of } from 'rxjs';

import { FeatureComparison } from '../../../models/feature-comparison.model';
import { JournalFieldComparison } from '../../../models/journal-field.model';

import { FileExpenseData } from '../../../models/file-expense-data.model';
import { EYE_UPDATE_FF, EYE_UPDATE_JR, INPUT_VAT_OPTION, SUPPLIER_OPTION, EXPENSE_OPTION, PAYMENT_OPTION, CURRENCY_TYPE, CODETYPE_OPTIONS, VAT_FOR_DATE } from '../../../services/account-api.constants';
import { FEATURE_FIELD_CONFIG, AUTOCOMPLETE_FIELD_ACTIONS_MT0, AUTOCOMPLETE_FIELD_ACTIONS_MT1 } from './eye-dialog.constanst';

import { MPP_RECALC_SUMS, EXPENSE_LOT_OPTIONS, GET_IND_JOR_BY_FILE, GET_FIL_EXPS, GET_FEATURES_COMP } from '../../../services/account-api.constants';


import { AjaxService } from '../../../services/ajax.service';
import { CreateAccountService } from '../../management/create-account/create-account.service';
import { MessageService } from 'primeng/api';
import { TranslateService } from '../../../services/translate.service';
import { ViewScopeService } from '../../../services/view-scope.service';
import { AuthStateService } from '../../../services/auth-state.service';


@Injectable({
	providedIn: 'root'
})
export class EyeDialogService {
	constructor(
		private ajaxService: AjaxService,
		private viewScopeService: ViewScopeService,
		private createAccountService: CreateAccountService,
		private messageService: MessageService,
		private translateServ: TranslateService,
		private authStateService: AuthStateService
	) { }

	/**
	 * Returns a dialog configuration object for known dialog functions.
	 * The component that will actually open the dialog (has DialogService) should call DialogService.open()
	 */
	public getDialogConfigFor(functionName: string, params?: any): { component: any, data?: any, header?: string, width?: string } | null {
		switch (functionName) 
		{
			case 'openKheshbonZkhutDialog':
				if (!this.createAccountService.isKeyEmpty()) {
					this.messageService.add({
						severity: 'error',
						summary: this.translateServ?.dictionary?.['ATTENTION'] || 'Error',
						detail: this.translateServ?.dictionary?.['NEW_USER_PREVIOUS_NOT_COMPLETED'] || "A new user cannot be created because the previous user's process has not yet been completed.",
						life: 7000,
						sticky: false
					});
					return null;
				}
				return {
					component: BasicInfoComponent,
					data: { isFastMode: true, prefill: params },
					header: 'Create Supplier',
					width: '700px'
				};
			default:
				return null;
		}
	}

	public getIndiviadualInvoice(fileRecId: string, customerRecID: string): Observable<any> {
		return this.ajaxService.getData(this.ajaxService.getBaseOfApi()+ GET_IND_JOR_BY_FILE + fileRecId + '/' + customerRecID) as Observable<FeatureComparison[]>;
	}

	public getFileExpensesData(recordId: number): Observable<FileExpenseData[]> {
		return this.ajaxService.getData(this.ajaxService.getBaseOfApi() + GET_FIL_EXPS + recordId + '/' + this.viewScopeService.getCurrentOpertaingUserId().toString()) as Observable<FileExpenseData[]>;
	}

	// operation: True for insert, False for update
	public buildExpenseTabData(operation: boolean, leadingId: string, itemId: string, expCode: string) {
		const userRecId = this.viewScopeService.getCurrentOpertaingUserId().toString() || '';
		const payload: any = {
			"Confidence": "1.0",
			"item": itemId,
			"ExpenseCode": expCode,
			"CustomerRecID": this.viewScopeService.getCurrentCustomer(),
			"Descr": "inserted by: " + this.authStateService.getFirstName() + ' ' + this.authStateService.getLastName(),
			"UserRecID": userRecId
		};
		if (operation) {
			payload["FileRecID"] = leadingId;
		}
		else {
			payload["RecID"] = leadingId;
		}
		return payload;
	}

	public updateFeaturesTab(features: FeatureComparison[], fileRecID: number) {
		const payloadObj = this.createSaveFFPayload(features, fileRecID);
		return this.ajaxService.updateObjectData(this.ajaxService.getBaseOfApi() + EYE_UPDATE_FF, payloadObj);
	}

	public updateJournalsTab(fields: JournalFieldComparison[], fileRecID: number, journalRecID: number, supRecID: string | null) {
		const payloadObj = this.createSaveJRPayload(fields, fileRecID, journalRecID, supRecID ?? '');
		return this.ajaxService.addObjectData(this.ajaxService.getBaseOfApi() + EYE_UPDATE_JR, payloadObj);
	}


	public getFeatureComparisonData(recordId: number, customerRecID: string): Observable<FeatureComparison[]> {
		return this.ajaxService.getData(this.ajaxService.getBaseOfApi() + GET_FEATURES_COMP + recordId + '/' + customerRecID) as Observable<FeatureComparison[]>;
	}

	public createSaveFFPayload(features: FeatureComparison[], fileRecID: number) {
		const userRecID = this.viewScopeService.getCurrentOpertaingUserId();

		const FF = features.map(f => {
			const file_feature_id = f.ID ?? null;
			const feature_id = f.RecID ?? null;
			return {
				"file_feature_id": file_feature_id,
				"file_feature_value": f.FeatureValueStd ?? '',
				"feature_id": file_feature_id ? null : feature_id
			};
		});

		const result = {
			"FileRecID": fileRecID,
			"UserRecID": userRecID,
			"FF": FF
		};
		console.log('createSaveFFPayload result (raw):', JSON.stringify(result));
		return JSON.stringify(result);
	}

	public createSaveJRPayload(features: JournalFieldComparison[], fileRecID: number, journalRecID: number, supRecID: string | undefined) {
		const userRecID = this.viewScopeService.getCurrentOpertaingUserId();
		const custRecID = this.viewScopeService.getCurrentCustomer();

		const JR = features.map(f => {
			const journal_field_number = f.FieldName ?? null;
			const journal_field_value = f.FieldValue ?? null;
			return {
				"Field_name": journal_field_number,
				"Field_value": journal_field_value
			};
		});

		const result = {
			"FileRecID": fileRecID,
			"UserRecID": userRecID,
			"CustomerRecID": custRecID,
			"SupplierRecID": supRecID === undefined ? '' : supRecID,
			"JournalID": journalRecID,
			"Fields": JR
		};
		console.log('createSaveJRPayload result (raw):', JSON.stringify(result));
		return JSON.stringify(result);
	}

	public getExpenseLotData(customerRecID: string): Observable<FileExpenseData[]> {
		// Ensure Category6111Type is always present in the returned objects
		return this.ajaxService.getData(this.ajaxService.getBaseOfApi() + EXPENSE_LOT_OPTIONS + customerRecID + '/' + this.viewScopeService.getCurrentOpertaingUserId().toString()).pipe(
			// Map each item to ensure Category6111Type is present
			// If the API response is not an array, fallback to empty array
			// @ts-ignore
			map((data: any) => Array.isArray(data) ? data.map((item: any) => ({
				...item,
				Category6111Type: item.Category6111Type || item.category6111Type || ''
			})) : [])
		) as Observable<FileExpenseData[]>;
	}

	public reCalcTotals(keys: string[], values: number[], fixingIndex: number) {
		const payloadObj = this.createCalcSet(keys, values, fixingIndex, this.viewScopeService.getCurrentOpertaingUserId()!);
		return this.ajaxService.updateObjectData(this.ajaxService.getBaseOfApi() + MPP_RECALC_SUMS, payloadObj);
	}

	private createCalcSet(keys: (string | number)[], values: number[], fixFeatureIndex: number, userRecID: number) {
		// Build the details object by pairing keys and values
		const details: { [key: string]: number } = {};
		for (let i = 0; i < keys.length; i++) {
			const key = String(keys[i]);
			details[key] = values[i] ?? 0;
		}
		// The 'fix' key is the key at fixFeatureIndex
		const fix = String(keys[fixFeatureIndex] ?? '');
		return {
			fix,
			UserRecID: userRecID,
			details
		};
	}


	public loadSelectionForJournalEdit(coreOfAPI: string): Observable<any> {
		const prefixOfAPI = this.ajaxService.getBaseOfApi() + '/api/';
		const currOperatorID = this.viewScopeService.getCurrentOpertaingUserId();
		const currCustomerID = this.viewScopeService.getCurrentCustomer();

		let apiPath = coreOfAPI;

		switch (coreOfAPI) {
			case EXPENSE_OPTION:
			case PAYMENT_OPTION:
			case INPUT_VAT_OPTION:
			case CODETYPE_OPTIONS:
				apiPath += '/' + currCustomerID + '/' + currOperatorID;
				break;
			case SUPPLIER_OPTION:
				apiPath += '/' + currCustomerID + '/100/' + currOperatorID;
				break;
			case CURRENCY_TYPE:
				apiPath += '/' + currOperatorID;
				break;
			default:
				console.error("Developer? You messed up in eye-dialog... Try check the load of selection.");
				return of([]); // Return empty observable for unknown case
		}

		console.warn("Api that we will call is: " + prefixOfAPI + apiPath);

		return this.ajaxService.getData(prefixOfAPI + apiPath);
	}


	/**
	 * General utility to process selection data from loadSelectionForJournalEdit.
	 * @param api$ Observable<any[]> from loadSelectionForJournalEdit
	 * @param fieldsToConcat Array of field names to concatenate for display
	 * @param valueField Field name to use as value
	 * @returns Observable of array with label, value, and full object
	 */
	public processSelectionData(api$: Observable<any>, fieldsToConcat: string[], valueField: string): Observable<Array<{ label: string, value: any, full: any }>> {
		return api$.pipe(
			map((data: any[]) => Array.isArray(data) ? data.map(item => ({
				label: fieldsToConcat.map(f => item[f]).join(' - '),
				value: item[valueField],
				full: item
			})) : [])
		);
	}


	/**
	 * Get autocomplete options and update mapping for a given field and MT value.
	 * @param fieldName The field being edited (e.g., 'Kheshbon_Khova_2')
	 * @param mtValue The value of MT (0 or 1)
	 * @returns Observable with { options, action } where options is the autocomplete array and action is the update mapping
	 */
	public getAutoCompleteOptionsAndAction(fieldName: string, mtValue: number): Observable<{ options: Array<{ label: string, value: any, full: any }>, action: any }> {
		// Pick the correct action mapping for MT
		const actionMap = mtValue === 0 ? AUTOCOMPLETE_FIELD_ACTIONS_MT0 : AUTOCOMPLETE_FIELD_ACTIONS_MT1;
		const action = actionMap[fieldName];
		// Find config for the field
		const fieldConfig = FEATURE_FIELD_CONFIG.find(f => f.name === fieldName);
		if (!fieldConfig || fieldConfig.type !== 'autocomplete') return of({ options: [], action });

		// Determine which autocomplete key to use
		const apiKey = mtValue === 0 ? fieldConfig.autoCompleteKey1 : fieldConfig.autoCompleteKey2;
		if (!apiKey) return of({ options: [], action });


		// Use autoCompleteLabelProps1/2 if set, otherwise fallback to action mapping
		let fieldsToConcat: string[] = [];
		let valueField = '';
		const labelProps = mtValue === 0 ? fieldConfig.autoCompleteLabelProps1 : fieldConfig.autoCompleteLabelProps2;
		if (labelProps) {
			if (Array.isArray(labelProps)) {
				fieldsToConcat = labelProps;
			} else if (typeof labelProps === 'string') {
				fieldsToConcat = [labelProps];
			}
			// Use first property as valueField by default
			valueField = this.getSourcePropertyForField(fieldName, mtValue)!;
		} else if (action && action.updates && action.updates.length > 0) {
			valueField = action.updates[0].sourceProperty;
			fieldsToConcat = action.updates.map(u => u.sourceProperty);
		} else {
			fieldsToConcat = ['name'];
			valueField = 'name';
		}
		const api$ = this.loadSelectionForJournalEdit(apiKey);
		return this.processSelectionData(api$, fieldsToConcat, valueField).pipe(
			map(options => ({ options, action }))
		);
	}




	/**
	 * Sets Skhum_khova_2_shek = 0 and Skhum_khova_1_shek = Skhum_Zkhut_1_shek for the given row,
	 * but only if Kheshbon_Khova_2 is empty/null/undefined/blank.
	 * @param row The row object to update
	 */
	public setVatZero(row: any): void {
		if (!row) return;
		// Only set if Kheshbon_Khova_2 is empty
		if (!row.Kheshbon_Khova_2 || row.Kheshbon_Khova_2 === '' || row.Kheshbon_Khova_2 === null) {
			row.Skhum_khova_2_shek = 0;
			row.Skhum_khova_1_shek = row.Skhum_Zkhut_1_shek;
		}
	}

	/**
	 * Tracks Input_VAT changes and triggers calculations if changed..
	 * When CodeMoveType (CodeSugTnua) is changed, update the totals values.
	 * Preform calculation starting with the "Total with tax", and go down.
	 * @param row The row object to update
	 */
	public checkAffectOfCodeMoveType(row: any): void {
		if (!row) return;
		const dateUS = row.Taarikh_Erekh ? this.convertJsDateToISO(row.Taarikh_Erekh) : this.todaysDateInUSFormat();

		this.definedVatRateForDate(dateUS).subscribe((standartVat: number) => {
			row.Skhum_khova_2_shek = Number(((row.Skhum_Zkhut_1_shek * row.Input_VAT) / (100 + standartVat)).toFixed(2));
			row.Skhum_khova_1_shek = Number((row.Skhum_Zkhut_1_shek - row.Skhum_khova_2_shek).toFixed(2));

			this.triggerVatValue(row);
		});
	}

	public recalculateTotalWithoutTax(row: any): void {
		if (!row) return;
		row.Skhum_khova_1_shek = Number((row.Skhum_Zkhut_1_shek - row.Skhum_khova_2_shek).toFixed(2));

		this.triggerVatValue(row);
	}


	private triggerVatValue(row: any): void {
		if (row && row.MT === '1') return; //  Do not operate recipts!

		const inputVatOptions = this.loadSelectionForJournalEdit(INPUT_VAT_OPTION);

		inputVatOptions.subscribe(data => {
			if (row.Skhum_khova_2_shek != 0) {
				if (data && data.length > 0) {
					row.Kheshbon_Khova_2 = data[0].customer_vat_expences_num;
					row.Kheshbon_Khova_2_name = data[0].name;
				}
			}
			else {
				// Set from second item (index 1)
				if (data && data.length > 1) {
					row.Kheshbon_Khova_2 = data[1].customer_vat_expences_num;
					row.Kheshbon_Khova_2_name = data[1].name;
				}
			}
		});
	}

	/**
	 * Returns the type of a field as defined in FEATURE_FIELD_CONFIG.
	 * @param fieldName The name of the field
	 * @returns The type of the field (e.g., 'number', 'money', 'text', 'autocomplete', 'date'), or undefined if not found
	 */
	public getFieldType(fieldName: string): string | undefined {
		return FEATURE_FIELD_CONFIG.find(f => f.name === fieldName)?.type;
	}


	/**
	 * Returns the sourceProperty for a given fieldName and mtValue (0 or 1) from the correct AUTOCOMPLETE_FIELD_ACTIONS_MT0/1.
	 * It finds the action for fieldName, then finds the update where targetField === fieldName, and returns the sourceProperty.
	 * If not found, returns undefined.
	 */
	public getSourcePropertyForField(fieldName: string, mtValue: number): string | undefined {
		const actionMap = mtValue === 0 ? AUTOCOMPLETE_FIELD_ACTIONS_MT0 : AUTOCOMPLETE_FIELD_ACTIONS_MT1;
		const action = actionMap[fieldName];
		if (!action || !Array.isArray(action.updates)) return undefined;
		const update = action.updates.find(u => u.targetField === fieldName);
		return update ? update.sourceProperty : undefined;
	}

	public getPostFunctionNameForField(fieldName: string, mtValue: number): string | undefined {
		const actionMap = mtValue === 0 ? AUTOCOMPLETE_FIELD_ACTIONS_MT0 : AUTOCOMPLETE_FIELD_ACTIONS_MT1;
		const action = actionMap[fieldName];

		return !action || !Array.isArray(action.updates) ? undefined : action.afterSelectFn;
	}

	/**
	 * Gets the VAT rate for a given date from the API and returns only the Rate value (number).
	 * @param date Date string in YYYY-MM-DD format
	 * @returns Observable<number> with the VAT rate
	 */
	private definedVatRateForDate(date: string): Observable<number> {
		return this.ajaxService.getData(this.ajaxService.getBaseOfApi() + VAT_FOR_DATE + date + '/' + this.viewScopeService.getCurrentOpertaingUserId())
			.pipe(
				map((res: any) => {
					// Expecting { Table: [{ Rate: number, ... }] }. Else 0.
					return res && res.Table && Array.isArray(res.Table) && res.Table.length > 0 ? res.Table[0].Rate : 0;
				})
			);
	}


	/**
	 * Converts a date string from EU format (DD/MM/YYYY) to American format (YYYY-MM-DD).
	 * @param euDate Date string in DD/MM/YYYY or DD/MM/YYYY HH:mm:ss format
	 * @returns Date string in YYYY-MM-DD or YYYY-MM-DD HH:mm:ss format
	 */
	private convertDateEUtoUS(euDate: string): string {
		if (!euDate) return '';
		// Split date and time if present
		const [datePart, timePart] = euDate.split(' ');
		const parts = datePart.split('/');
		if (parts.length !== 3) return euDate; // Invalid format, return as is
		const [day, month, year] = parts;
		let usDate = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
		if (timePart) usDate += ' ' + timePart;
		return usDate;
	}


	/**
	 * Converts a JS Date string (e.g. 'Sun Apr 05 2026 00:00:00 GMT+0300 (Israel Daylight Time)') to 'YYYY-MM-DD'.
	 * @param jsDate Date string in JS Date format
	 * @returns Date string in 'YYYY-MM-DD' format
	 */
	public convertJsDateToISO(jsDate: string): string {
		if (!jsDate) return '';
		const d = new Date(jsDate);
		if (isNaN(d.getTime())) return '';
		// Pad month and day
		const month = (d.getMonth() + 1).toString().padStart(2, '0');
		const day = d.getDate().toString().padStart(2, '0');
		return `${d.getFullYear()}-${month}-${day}`;
	}

	private todaysDateInUSFormat(): string {
		const today = new Date();
		const month = (today.getMonth() + 1).toString().padStart(2, '0');
		const day = today.getDate().toString().padStart(2, '0');
		return `${today.getFullYear()}-${month}-${day}`;
	}
}